import pdfMake from 'pdfmake/build/pdfmake'
// eslint-disable-next-line
import pdfFonts from 'pdfmake/build/vfs_fonts'
import html2canvas from 'html2canvas'

import logo from '../../../../assets/logos/partner-brite-logo-light.png'

import { insertIf } from '../../../../helpers/common'
import { getBase64FromUrl } from '../../../../helpers/files'

import { mediumGrey, darkGrey } from '../../../../styles/const/colors'

// pdfMake.vfs = pdfFonts.pdfMake.vfs

// pdfMake.vfs = pdfFonts.pdfMake.vfs;
const A3_WIDTH = 842
// const A4_HEIGHT = 842
const PAGE_MARGIN_Y = 20
const PAGE_MARGIN_X = 20

const availablePageWidth = A3_WIDTH - PAGE_MARGIN_X * 2

export const getSectionsScreenshots = async (sections, marginTop = 8, skipFirstMargin = true) => {
  const content = []

  for (let i = 0; i < sections.length; i++) {
    const section = sections[i]
    if (
      !section ||
      // Skip screenshotting sections that are not visible
      section.offsetHeight === 0
    )
      continue

    // Generate canvas for each section and push to content
    const canvas = await html2canvas(section, {
      backgroundColor: null,
      useCORS: true // Required for loading external images (e.g., SDG icons)
    })

    const dataUrl = canvas.toDataURL()

    content.push({
      image: dataUrl,
      width: availablePageWidth,
      // First section can optionally skip top margin (e.g., for document header)
      marginTop: skipFirstMargin && content.length === 0 ? 0 : marginTop
    })
  }

  return content
}

const generatePdfReport = async ({ dateRangeLabel, title, contentSections, fileName, appName }) => {
  const logoBase64 = await getBase64FromUrl(logo)

  const content = [
    {
      text: title,
      alignment: 'center',
      color: darkGrey,
      marginBottom: 10,
      fontSize: 15
    },
    ...contentSections
  ]

  let docDefinition = {
    pageSize: 'A3',
    pageMargins: [PAGE_MARGIN_Y, PAGE_MARGIN_X],
    content,
    images: {
      logo: logoBase64
    },
    footer: function (currentPage) {
      return [
        {
          columns: [
            ...insertIf(dateRangeLabel, {
              text: `Reporting date range: ${dateRangeLabel}`,
              alignment: 'left',
              margin: [PAGE_MARGIN_X, 0, 0, 0],
              color: mediumGrey,
              fontSize: 8
            }),
            {
              text: `Generated in ${appName} | ` + currentPage.toString(),
              alignment: 'right',
              margin: [0, 0, PAGE_MARGIN_X, 0],
              color: mediumGrey,
              fontSize: 8
            }
          ]
        },
        {
          image: 'logo',
          width: 10,
          height: 10,
          absolutePosition: { x: 705, y: 0 }
        }
      ]
    }
  }

  pdfMake.createPdf(docDefinition).download(fileName)
}

export default generatePdfReport
